import { render, staticRenderFns } from "./ModelosTabelaBuscar.vue?vue&type=template&id=b93d929c"
import script from "./ModelosTabelaBuscar.vue?vue&type=script&lang=js"
export * from "./ModelosTabelaBuscar.vue?vue&type=script&lang=js"
import style0 from "./ModelosTabelaBuscar.vue?vue&type=style&index=0&id=b93d929c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports